import { apolloClient } from "../../vue-apollo";
import { exMut } from "../../graphql/gql.js";
import { USER, EDIT_PASSWORD, VERIFY_PASSWORD } from "@/graphql/mutations";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
  },
  mutations: {
    SET_USER_IMAGE(_, data) {
      const { imagen_perfil } = data;
      let user = Vue.prototype.$ls.get("user");
      user = { ...user, imagen_perfil };
      Vue.prototype.$ls.set("user", user);
    },
    SET_USER_PROFILE(_, data) {
      const { telefono_movil, anexo, telefono_fijo, correo } = data;
      let user = Vue.prototype.$ls.get("user");
      user = { ...user, telefono_movil, anexo, telefono_fijo, correo };
      Vue.prototype.$ls.set("user", user);
    },
  },
  actions: {
    async editPasswordAction(_, data_) {
      const params = {
        mutation: EDIT_PASSWORD,
        variables: data_,
      };

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.editPasswordUsuarioUpdate;
      } catch (e) {
        console.error("Error en cambiar contraseña:", e);
      }
      return response;
    },

    async verifyPasswordAction(_, data_) {
      const params = {
        mutation: VERIFY_PASSWORD,
        variables: data_,
      };

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.checkCurrentPasswordBoolean;
      } catch (e) {
        console.error("Error verificando contraseña:", e);
      }
      return response;
    },
    async editImage({ commit }, data) {
      return await exMut(
        USER.EDIT_IMAGEN_PERFIL,
        data,
        "Imagen de perfil editada exitosamente",
        "No se pudo editar la imagen"
      )
        .then((res) => {
          console.log({res});
          commit("SET_USER_IMAGE", res);
          return res;
        })
        .catch((err) => {
          console.log(err);
          return null;
        });
    },
    async editProfile({ commit }, data) {
      return await exMut(
        USER.EDIT_PERFIL,
        data,
        "Perfil editado exitosamente",
        "No se pudo editar el perfil"
      )
        .then((res) => {
          commit("SET_USER_PROFILE", res);
          return res;
        })
        .catch(() => null);
    },
  },
};
